import { ProviderStrings } from '@fs/identity.js'
import { useMemo } from 'react'

export default function useProviderText() {
  return useMemo(getProviderTextFromUrl, [])
}

export function getProviderTextFromUrl() {
  const provider = new URLSearchParams(window.location.search).get('provider')
  return ProviderStrings[provider]?.() || ''
}
